import React, { useEffect, useState } from 'react';
import { Box, Grid, IconButton, List, ListItem } from '@mui/material';
import { Square, Warning } from '@mui/icons-material';
import { Typography } from '@uhc-tempo/components';
import FlagIcon from '@mui/icons-material/Flag';
import CloseIcon from '@mui/icons-material/Close';
import { OON_NO_RATES_DISCLAIMER_ID, PRIOR_AUTH_IDS } from '../../../constants';
import '../../../styles/cssStyles.css';

export default function ServiceNoteDisclaimers(props) {
    const { serviceNoteDisclaimers, handleOpenDialog } = props;
    const initializeServiceNotesOpen = () => {
        const initialServiceNotesOpenById = {};

        if (serviceNoteDisclaimers) {
            serviceNoteDisclaimers.forEach((val) => {
                initialServiceNotesOpenById[val.id] = true;
            });
        }
        return initialServiceNotesOpenById;
    };
    const priorAuthIds = Object.values(PRIOR_AUTH_IDS); // IDs for prior auth
    useEffect(() => {
        setServiceNotesOpenById(initializeServiceNotesOpen());
    }, [serviceNoteDisclaimers]);

    const [serviceNotesOpenById, setServiceNotesOpenById] = useState(initializeServiceNotesOpen());
    const [importantNoticesOpen, setImportantNoticesOpen] = useState(true);

    const handleServiceNotesClose = (id) => {
        const objCopy = JSON.parse(JSON.stringify(serviceNotesOpenById));

        serviceNoteDisclaimers.forEach((note) => {
            if (note.id == id) {
                objCopy[note.id] = false;
            }
        });
        setServiceNotesOpenById(objCopy);
    };

    const initializeDisclaimersToDisplay = (disclaimers) => {
        const importantNoticeDisclaimers = [
            'F',
            'G',
            'I',
            'J',
            'K',
            'A',
            'Z',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'T',
        ]; // TODO: update this with any additional serviceNote ids/keys as custom disclaimers are added
        let disclaimersToDisplay = { standard: [], importantNotices: [] };
        disclaimers.forEach((disc) => {
            if (importantNoticeDisclaimers.includes(disc.id) && !priorAuthIds.includes(disc.id)) {
                disclaimersToDisplay.importantNotices.push(disc);
            } else {
                disclaimersToDisplay.standard.push(disc);
            }
        });
        return disclaimersToDisplay;
    };

    // prior auth, treatment limits, etc
    const renderStandardDisclaimer = (disclaimers) => {
        let disclaimersToDisplay = disclaimers.standard?.filter(
            (disclaimer) => disclaimer.id != OON_NO_RATES_DISCLAIMER_ID
        );
        if (disclaimersToDisplay?.length > 0) {
            return disclaimersToDisplay.map((disc, index) => {
                const disclaimerText = disc.text.split(':');
                let disclaimerTextForDisplay =
                    disclaimerText?.length == 1 ? disclaimerText[0] : `${disclaimerText[0]}: `;
                // Check if the disclaimer ID is in the list of prior auth IDs
                const isPriorAuth = priorAuthIds.includes(disc.id);

                return (
                    serviceNotesOpenById[disc.id] && (
                        <Box
                            key={`service-disclaimer-parent-div${disc.id}`}
                            component="div"
                            my={3}
                            px={3}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                bgcolor: isPriorAuth ? '#FEF9EA' : '#E5F8FB',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                            }}
                        >
                            <Box>
                                <div key={`service-disclaimer-div${disc.id}`}>
                                    <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'start',
                                            flexWrap: 'nowrap',
                                            paddingTop: isPriorAuth ? '0px' : '10px',
                                        }}
                                    >
                                        {isPriorAuth ? (
                                            <Grid item sx={{ position: 'relative' }}>
                                                <Square
                                                    style={{
                                                        color: '#19191A',
                                                    }}
                                                    sx={{
                                                        position: 'absolute',
                                                        height: '12px',
                                                        width: '30px',
                                                        left: '5px',
                                                        top: '16.5px',
                                                    }}
                                                />
                                                <Warning
                                                    sx={{
                                                        position: 'sticky',
                                                        zIndex: '1',
                                                    }}
                                                    style={{
                                                        color: '#F5B700',
                                                    }}
                                                />{' '}
                                            </Grid>
                                        ) : (
                                            <Grid item>
                                                <FlagIcon style={{ color: '#002677' }} />{' '}
                                            </Grid>
                                        )}
                                        <Grid
                                            item
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                            }}
                                        >
                                            <Typography.Paragraph>
                                                <span
                                                    style={{
                                                        fontWeight: 700,
                                                        marginBottom: '0px',
                                                        color: '#323334',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    {disclaimerTextForDisplay}
                                                </span>
                                                {disclaimerText[1]}
                                            </Typography.Paragraph>
                                            {isPriorAuth && (
                                                <Grid item>
                                                    <Typography.Link
                                                        data-testid="priorAuhtLink"
                                                        style={{
                                                            cursor: 'pointer',
                                                            fontFamily: 'UHC2020 Sans, sans-serif',
                                                            fontStyle: 'Normal',
                                                            fontSize: '16px',
                                                            lineHeight: '20px',
                                                            color: '#196ECF',
                                                            fontWeight: 700,
                                                            textDecoration: 'none',
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleOpenDialog();
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key == 'Enter' || e.key == ' ') {
                                                                handleOpenDialog();
                                                            }
                                                        }}
                                                        tabIndex="0"
                                                    >
                                                        About prior authorization &gt;
                                                    </Typography.Link>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </div>
                            </Box>
                            {!isPriorAuth && (
                                <IconButton
                                    title="closeServiceDisclaimer"
                                    onClick={() => handleServiceNotesClose(disc.id)}
                                    aria-label="Close service disclaimer display"
                                >
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </Box>
                    )
                );
            });
        }
        return null;
    };

    const importantNoticeSubHeader = (
        <Grid container direction="row" alignItems="center" wrap="nowrap" spacing={1}>
            <Grid item>
                <FlagIcon style={{ color: '#002677' }} />{' '}
            </Grid>
            <Grid item>
                <Typography.Paragraph
                    style={{
                        fontWeight: 700,
                        marginBottom: '0px',
                    }}
                >
                    Important notices:
                </Typography.Paragraph>
            </Grid>
        </Grid>
    );

    // custom population disclaimers - HCA, Empire, etc.
    const renderImportantNoticesDisclaimers = (disclaimersToDisplay) => {
        if (disclaimersToDisplay.importantNotices?.length > 0 && importantNoticesOpen) {
            return (
                <Box
                    key={`important-notices-disclaimer-parent-div`}
                    component="div"
                    my={3}
                    px={3}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: '#E5F8FB',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                    }}
                >
                    <Box>
                        <div key={`important-notices-disclaimer-div`}>
                            <Grid
                                container
                                spacing={1}
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                role="alert"
                            >
                                <Grid item>
                                    <List
                                        dense={true}
                                        subheader={importantNoticeSubHeader}
                                        sx={{
                                            listStyleType: 'disc',
                                            listStylePosition: 'inside',
                                        }}
                                    >
                                        {disclaimersToDisplay.importantNotices.map(
                                            (disc, index) => {
                                                return (
                                                    <Typography.Paragraph
                                                        style={{
                                                            marginBottom: '0px',
                                                        }}
                                                        key={`important-notice-typography${disc.id}-${index}`}
                                                    >
                                                        <ListItem
                                                            key={`important-notice-item${disc.id}-${index}`}
                                                            sx={{
                                                                display: 'list-item',
                                                            }}
                                                        >
                                                            {disc.text}
                                                        </ListItem>
                                                    </Typography.Paragraph>
                                                );
                                            }
                                        )}
                                    </List>
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                    <IconButton
                        title="closeImportantNotices"
                        onClick={() => setImportantNoticesOpen(false)}
                        aria-label="Close important notices display"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            );
        }
        return null;
    };

    const renderServiceNoteDisclaimers = () => {
        if (serviceNoteDisclaimers?.length > 0) {
            const disclaimersToDisplay = initializeDisclaimersToDisplay(serviceNoteDisclaimers);
            return (
                <div>
                    {renderStandardDisclaimer(disclaimersToDisplay)}
                    {renderImportantNoticesDisclaimers(disclaimersToDisplay)}
                </div>
            );
        }
        return null;
    };

    return renderServiceNoteDisclaimers();
}
